<template>
  <aside :class="{ visible: getSidebarStatus }">
     <span class="slogan">
      Symptom
      <span>&</span><br> Activity Monitoring
    </span>
    <nav>
      <header>Symptoms</header>
      <ul>
        <li>
          <router-link to="/symptom/sleep" @click.native="toggleSidebar">
            <span class="link-wrapper">
              <img src="/app/img/sleep-sidebar.svg" role="presentation">
              <span>Sleep</span>
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/symptom/pain" @click.native="toggleSidebar">
            <img src="/app/img/pain-sidebar.svg" role="presentation">
            <span>Pain</span>
          </router-link>
        </li>
        <li>
          <router-link to="/symptom/affect" @click.native="toggleSidebar">
            <img src="/app/img/affect-sidebar.svg" role="presentation">
            <span>Affect</span>
          </router-link>
        </li>
        <li>
          <router-link to="/symptom/cognitive-function" @click.native="toggleSidebar">
            <img src="/app/img/cognitive-function-sidebar.svg" role="presentation">
            <span>Cognitive Function</span>
          </router-link>
        </li>
        <li>
          <router-link to="/symptom/energy-fatigue" @click.native="toggleSidebar">
            <img src="/app/img/energy-fatigue-sidebar.svg" role="presentation">
            <span>Energy / Fatigue</span>
          </router-link>
        </li>
      </ul>
      <header>Behaviors</header>
      <ul>
        <li>
          <router-link to="/behavior/physical-activity" @click.native="toggleSidebar">
            <img src="/app/img/physical-activity-sidebar.svg" role="presentation">
            <span>Physical Activity</span>
          </router-link>
        </li>
        <li>
          <router-link to="/behavior/pacing" @click.native="toggleSidebar">
            <img src="/app/img/pacing-sidebar.svg" role="presentation">
            <span>Pacing</span>
          </router-link>
        </li>
        <li>
          <router-link to="/worksheets">
            <img src="/app/img/worksheet-sidebar.svg" role="presentation">
            <span>Self-care Worksheets</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getSidebarStatus"])
  },

  methods: {
    ...mapMutations(["hideSidebar"]),

    toggleSidebar() {
      this.hideSidebar();
    }
  }
};
</script>

<style scoped>
aside {
  -webkit-overflow-scrolling: touch;
  background-color: var(--almost-black);
  bottom: 0;
  color: var(--eggshell);
  left: 0;
  padding: 2rem 0 2rem 1rem;
  position: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
  top: 75px;
  width: 255px;
  z-index: 1;
}

header {
  font-family: BebasNeue, serif;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  margin-bottom: 1.5rem;
}

a {
  color: var(--eggshell);
  display: block;
  font-weight: 600;
  overflow: hidden;
  text-decoration: none;
}

a::after {
  content: "";
  display: block;
  background-color: var(--michigan-maize);
  height: 5px;
  margin-left: 2rem;
  margin-top: 0.5rem;
  transition: width 0.25s ease-out;
  width: 0;
}

a img {
  margin-right: 1rem;
}

.slogan {
  color: var(--eggshell);
  display: none;
  font-family: BebasNeue, serif;
  font-size: 2.1rem;
  line-height: 0.86;
  margin-bottom: 2rem;
  text-transform: uppercase;
}

.slogan span {
  color: var(--michigan-maize);
}

.link-wrapper {
  align-items: center;
  display: flex;
}

.router-link-active {
  color: var(--michigan-maize);
}

a:hover::after,
a:focus::after,
.router-link-active::after {
  transition: width 0.25s ease-in;
  width: 100%;
}

@media all and (max-width: 800px) {
  aside {
    transform: translateX(-255px);
    transition: transform 0.25s ease-out;
    top: 0;
    z-index: 5;
  }
  aside.visible {
    transform: translateX(0);
    transition: transform 0.25s ease-in;
  }
  .slogan {
    display: block;
  }
}
</style>
